var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { getLinkTarget } from '../../utils/variations';
import { Icon } from '../Icon';
import { isFieldValid } from '../../utils/validation';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const StyledLink = styled((_a) => {
    var { ariaLabel } = _a, others = __rest(_a, ["ariaLabel"]);
    const newProps = ariaLabel ? Object.assign(Object.assign({}, others), { 'aria-label': ariaLabel }) : Object.assign({}, others);
    return React.createElement(Link, Object.assign({}, newProps));
}) `
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  color: ${({ theme }) => theme.secondaryBlue};
  display: flex;
  justify-content: center;
  text-decoration: none;
  width: fit-content;
  font-size: 22px;
  line-height: 23px;
  padding: 3px 0px 3px 7px;
  margin-left: -7px;

  &:hover {
    color: ${({ theme }) => theme.tertiaryHoverBlue};
  }

  &:active {
    color: ${({ theme }) => theme.primaryBlack};
  }

  ${({ inverted }) => inverted &&
    css `
      color: ${({ theme }) => theme.primaryWhite};

      &:hover,
      &:focus,
      &:active {
        color: ${({ theme }) => theme.primaryWhite};
      }
    `}

  ${({ disabled }) => disabled &&
    css `
      color: ${({ theme }) => theme.greyDarkMedium};
      pointer-events: none;
    `}
`;
const StyledIcon = styled(Icon) `
  color: inherit;
  transform: rotate(90deg);
  margin-left: -5px;
`;
export const TextLink = (_a) => {
    var { field, textField, inverted, disabled, isNotTabbable } = _a, rest = __rest(_a, ["field", "textField", "inverted", "disabled", "isNotTabbable"]);
    if (!isFieldValid(field, 'href') && !isFieldValid(textField))
        return null;
    const { linktype, text: ariaLabel } = field && field.value;
    const text = textField && textField.value;
    return (React.createElement(OnClickFocusWrapper, null,
        React.createElement(StyledLink, Object.assign({ inverted: inverted, disabled: disabled, field: field, target: getLinkTarget(linktype), tabIndex: isNotTabbable ? -1 : 0, ariaLabel: ariaLabel }, rest),
            text,
            React.createElement(StyledIcon, { className: "material-icons" }, "arrow_drop_up"))));
};
